export default {
  mode: "index",
  backgroundColor: "rgb(255,255,255)",
  xPadding: 10,
  yPadding: 10,
  borderColor: "#C8C8C8",
  cornerRadius: 2,
  borderWidth: 1,
  titleFontSize: 10,
  titleFontStyle: "normal",
  titleFontColor: "#737373",
  bodyFontSize: 13,
  bodyFontStyle: "bold",
  bodyFontColor: "#3A3A3A",
};
